import Box from '@mui/material/Box';
import carDealerships from 'assets/data/clientsLogos';
import CarouselLoop from 'components/UI/CarouselLoop';
import type React from 'react';

const ZellerClients: React.FC = () => {
  return (
    <Box
      sx={{
        maxWidth: '100%',
        mt: { xs: 10, sm: 10, md: 0 },
      }}
    >
      <CarouselLoop itemWidth={120} itemMargin={16}>
        {carDealerships.map((image) => (
          <Box key={image} sx={{ width: 120, height: 120 }}>
            <img
              src={image}
              alt="client logo"
              style={{
                width: '100%',
                height: '100%',
                objectFit: 'contain',
                filter: 'grayscale(100%) brightness(0.6)',
              }}
            />
          </Box>
        ))}
      </CarouselLoop>
    </Box>
  );
};

export default ZellerClients;
